import { DialogTitle } from '@headlessui/react';
import { Modal } from '@retainerclub/common';
import PropTypes from 'prop-types';

function ManageScheduleModal({
  open,
  handleCloseModal,
  activeSchedule = null,
  refetch,
}) {
  return activeSchedule ? (
    <Modal open={open} setOpen={handleCloseModal} size="2xl">
      <div>
        <div className="text-center">
          <DialogTitle
            as="h2"
            className="font-semibold text-2xl text-rcgray-900 capitalize leading-6"
          >
            Update Schedule
          </DialogTitle>
        </div>
      </div>
    </Modal>
  ) : null;
}

ManageScheduleModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  activeSchedule: PropTypes.object,
  refetch: PropTypes.func.isRequired,
};

export default ManageScheduleModal;
